import { render, staticRenderFns } from "./DashboardNhanVien.vue?vue&type=template&id=3b2d41af&scoped=true"
import script from "./DashboardNhanVien.vue?vue&type=script&lang=js"
export * from "./DashboardNhanVien.vue?vue&type=script&lang=js"
import style0 from "./DashboardNhanVien.vue?vue&type=style&index=0&id=3b2d41af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2d41af",
  null
  
)

export default component.exports